import React from 'react';

const CashAppPreview = ({ data }) => {
    const senderName = data.senderName || 'John Doe';
    const senderHandle = data.senderHandle || '$johndoe123';
    const receiverName = data.receiverName || 'Jane Smith';
    const amount = typeof data.amount === 'number' ? data.amount.toFixed(2) : parseFloat(data.amount || 0).toFixed(2);
    const description = data.description || '';
    const identifier = '#PS' + Math.random().toString(36).substring(2, 8).toUpperCase();
    const fallbackEmail = data.fallbackEmail || 'support@skyhighntb.com';
    const receiverInitial = receiverName.charAt(0).toUpperCase();

    return (
        <div className="cashapp-preview">
            <div className="cashapp-card">
                <div className="cashapp-avatar">{receiverInitial}</div>
                <div className="cashapp-sender-name">{receiverName}</div>
                <div className="cashapp-from-label">Payment from <span className="cashapp-handle">{senderHandle}</span></div>

                <div className="cashapp-amount">${amount}</div>

                {description && (
                    <div className="cashapp-description">{description}</div>
                )}

                <div className="cashapp-status-row">
                    <div className="cashapp-status-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="12" fill="#00CCFF"/>
                            <path d="M12 6v12M6 12h12" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <div className="cashapp-status-text">More information is required to accept this payment</div>
                </div>

                <a href={`mailto:${fallbackEmail}`} className="cashapp-continue-btn">Continue</a>

                <div className="cashapp-details-table">
                    <div className="cashapp-detail-row">
                        <span>Amount</span>
                        <span>${amount}</span>
                    </div>
                    <div className="cashapp-detail-row">
                        <span>Fee</span>
                        <span>$0.00</span>
                    </div>
                    <div className="cashapp-detail-row">
                        <span>Identifier</span>
                        <span>{identifier}</span>
                    </div>
                    <div className="cashapp-detail-row">
                        <span>To</span>
                        <span>{receiverName}</span>
                    </div>
                    <div className="cashapp-detail-row">
                        <span>From</span>
                        <span>{senderName}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CashAppPreview;